import React from 'react';

import { WorkFeedSPV } from '../components/WorkFeedSPV/WorkFeedSPV';
import { EngagementsTabNavigation } from '../components/EngagementsTabNavigation/EngagementsTabNavigation';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type SingleWorkFeedItemPageProps = {
  name?: string;
};

export const SingleWorkFeedItemPage = ({
  name = 'SINGLE_WORK_FEED_ITEM_PAGE',
}: SingleWorkFeedItemPageProps) => {
  useDocumentTitle('Work Feed - Detail');
  return (
    <div data-test={name}>
      <EngagementsTabNavigation
        startTab="OPPORTUNITY_FEED_TAB"
        pathToEngagements="../.."
      />
      <WorkFeedSPV />
    </div>
  );
};
